export const sendNotification = async data => {
  console.log(data, "<<< noti data");
  const { title, body, metaData, accType, userId } = data;
  try {
    const response = await fetch(
      `${process.env.REACT_APP_CLOUD_FUNCTION_URL}/send-notification`,
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ title, body, metaData, accType, userId }),
      }
    ).then(res => res.json());

    if (response.success) {
      console.log("Notification sent successfully.");
      return true;
    } else {
      console.log("Error sending notification 1", response.response.responses);
      // throw new Error("Error sending notification");
    }
  } catch (error) {
    // throw error;
    console.log("Error sending notification", error);
  }
};
